/**
 * Simulação de CPF/CNPJ para superadmin/admin.
 *
 * O documento (CPF ou CNPJ — cotista PJ) é armazenado no sessionStorage e
 * enviado automaticamente como header `X-Sim-Cpf` em todas as requisições via
 * `api.ts`. O backend honra esse header apenas para usuários com permissão de
 * override (superadmin/admin).
 *
 * Não é necessário nenhum passo de "ativação" além de chamar setSimCpf().
 *
 * ⚠️ Segurança: o CPF de simulação vai no header `X-Sim-Cpf`, não na URL — o
 * cache de requisições (`cachedGet`) chaveia só pela URL. Ao trocar/limpar a
 * identidade simulada é OBRIGATÓRIO limpar o cache (`clearAll`), senão dados de
 * uma identidade seriam servidos sob outra.
 */
import { clearAll } from "./cache";

const KEY = "portal_sim_cpf";

export function getSimCpf(): string | null {
  return sessionStorage.getItem(KEY) || null;
}

export function setSimCpf(cpf: string): void {
  sessionStorage.setItem(KEY, cpf.replace(/\D/g, ""));
  clearAll(); // identidade mudou → invalida dados cacheados da anterior
}

export function clearSimCpf(): void {
  sessionStorage.removeItem(KEY);
  clearAll(); // volta à identidade real → invalida dados da simulação
}

/** No-op — CPF enviado via header X-Sim-Cpf automaticamente pelo api.ts. */
export function appendSimCpf(url: string): string {
  return url;
}

export function fmtSimCpf(documento: string): string {
  const n = documento.replace(/\D/g, "");
  if (n.length === 11) return n.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  if (n.length === 14) return n.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
  return documento;
}
